export function isValidSortCartBy(
  value: string | null | undefined
): value is 'alphabetical' | 'orderGuide' {
  return value === 'alphabetical' || value === 'orderGuide';
}

/**
 * Narrows the wire value of `pricingDateSource` to a source we know about.
 *
 * Codegen emits this enum with `'%future added value'`, so the generated type is
 * wider than the two real members. An unrecognised value becomes null, which
 * reads as "unset" and lets the backend apply its own default, rather than being
 * shown as a choice nobody made.
 */
export const toPricingDateSource = (
  value?: string | null
): 'ORDER_DATE' | 'DELIVERY_DATE' | null =>
  value === 'ORDER_DATE' || value === 'DELIVERY_DATE' ? value : null;
